module.exports = __webpack_public_path__ + "static/media/5.0446735a.jpg";